import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';

export interface DocumentKind {
  id: string;
  name: string;
  isActive: boolean;
  sortOrder: number;
}

export function useDocumentKinds(includeInactive = false) {
  return useQuery({
    queryKey: ['document-kinds', { includeInactive }],
    queryFn: async () => {
      const res = await apiClient.get<DocumentKind[]>('/api/v1/document-kinds', {
        params: { includeInactive }
      });
      return res.data;
    },
    staleTime: 30_000
  });
}

export function useCreateDocumentKind() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { name: string; sortOrder?: number }) => {
      const res = await apiClient.post<DocumentKind>('/api/v1/document-kinds', input);
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['document-kinds'] })
  });
}

export function useUpdateDocumentKind() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      ...body
    }: {
      id: string;
      name?: string;
      isActive?: boolean;
      sortOrder?: number;
    }) => {
      await apiClient.put(`/api/v1/document-kinds/${id}`, body);
      return id;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['document-kinds'] })
  });
}
